import * as React from 'react';

import {SidebarSection} from 'shells/setup/sidebar-section/sidebar-section';

import type {
    GetCustomFields_customFields as CustomFields,
    GetCustomFieldStagesets_stagesets as Stageset,
} from 'nutshell-graphql-types';

import {SettingsSidebar} from '../settings-sidebar';

import {LEAD_TAB_NAME} from './custom-fields';

import styles from './custom-fields.module.css';

type Props = {
    tab: string;
    isViewingArchived: boolean;
    selectedPipelineId: string | null | undefined;
    pipelines: Stageset[];
    customFields: CustomFields;
};

export function CustomFieldsSidebarSection(props: Props) {
    const numActiveCustomFields = props.customFields ? props.customFields.active.length : undefined;
    const numArchivedCustomFields = props.customFields
        ? props.customFields.archived.length
        : undefined;

    const showPipelinesSection =
        props.tab === LEAD_TAB_NAME && !NutClientConfig.hasLeadPageRedesignM3FF;

    return (
        <div className={styles['sidebar-section']}>
            <SidebarSection
                title='Data fields'
                links={[
                    {
                        to: `/setup/custom-field/${props.tab}`,
                        label: `All ${props.tab} fields`,
                        isActive: !props.isViewingArchived && props.selectedPipelineId === null,
                        count: numActiveCustomFields,
                    },
                    {
                        to: `/setup/custom-field/${props.tab}?archived=true`,
                        label: 'Archived fields',
                        type: 'archived',
                        isActive: props.isViewingArchived,
                        count: numArchivedCustomFields,
                    },
                ]}
            />
            {showPipelinesSection && (
                <SidebarSection
                    title='Pipelines'
                    links={props.pipelines.map((pipeline) => ({
                        to: `/setup/custom-field/lead?pipeline=${pipeline.id}`,
                        label: pipeline.name,
                        count: pipeline.customFields.shown.length,
                        isActive:
                            !props.isViewingArchived && props.selectedPipelineId === pipeline.id,
                    }))}
                />
            )}
            <SettingsSidebar glossaryKey={'/setup/custom-field'} />
        </div>
    );
}
